export default "<p>inter-stats-view works!</p>\n"